import React from 'react';
import { useSelector } from 'react-redux';
import SegmentedVideoPlayer, {
  SegmentedVideoPlayerInstance,
  SegmentedVideoPlayerProps,
} from 'components/SegmentedVideoPlayer';
import {
  getVideoMediaSegmentsSelector,
  getVideoSelector,
} from 'redux/modules/embed/selectors';
import useEditSceneModal from '../useEditSceneModal';
import { block } from '../utils';

export type EditScenePreviewPlayerProps = Pick<
  SegmentedVideoPlayerProps,
  'onTimeupdate'
>;

const EditScenePreviewPlayer = React.forwardRef<
  SegmentedVideoPlayerInstance,
  EditScenePreviewPlayerProps
>(({ onTimeupdate }, ref) => {
  const { videoId } = useEditSceneModal();
  const video = useSelector(getVideoSelector(videoId));
  const mediaSegments = useSelector(getVideoMediaSegmentsSelector(videoId));

  return (
    <SegmentedVideoPlayer
      className={block('preview-video-player')}
      onTimeupdate={onTimeupdate}
      ref={ref}
      segments={mediaSegments}
      src={video?.src}
    />
  );
});

export default EditScenePreviewPlayer;
